<app-shipment-sku #shipmentSkuComponent cdkDrag [cdkDragDisabled]="true"         
    *ngFor="let sku of skuList; let i = index" [sku]="sku" [skuScanQty]="sku.qty"
    [canBox]="true" [highlighted]="false" [canEdit]="false" [shipmentSkuBoxScan]="true" [box]="true">
</app-shipment-sku>